import Vue from 'vue'

export var bus = new Vue({
    methods: {

        Show_Modal() {
            this.$emit('ShowModal')
        },
        GetAllDealer(users, value) {
            this.$emit('AllDealers', users, value)
        },
        GetUsersByType(respose){
            this.$emit('GetUsersByType', respose)
        },
        GetEditDealer(user) {
            this.$emit('GetEditDealer', user)
        },
        ResponseCreateDealer(response) {
            this.$emit('ResponseCreateDealer', response)
        }
        ,
        ResponseUpdateDealer(response) {
            this.$emit('ResponseUpdateDealer', response)
        },
        GetValdateUser(response) {
            this.$emit('GetValdateUser', response)
        },
        GetAllRestaurant(data) {
            this.$emit('GetAllRestaurant', data)
        },
        GetAllDealerPagination(response) {
            this.$emit('GetAllDealerPagination', response)
        },
        OpenRute(user,user_id){
            this.$emit('OpenRute',user,user_id)
        },
        ResponseUpdateRestaurant(response){
            this.$emit('ResponseUpdateRestaurant',response)
        },
        GetAllDealerInforme(response){
            this.$emit('GetAllDealerInforme',response)
        },
        GetRepartidorOrder(response){
            this.$emit('GetRepartidorOrder', response)
        },
        GetUserAndRest(response){
            this.$emit('GetUserAndRest', response)
        },
        DeleteUser(response){
            this.$emit('DeleteUser', response)
        },
        GetAllOrderStatus(response) {
            this.$emit('GetAllOrderStatus', response)
        }

    }
})
